var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "42px",
    viewBox: "0 0 48 42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-2",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1766 0L2.02718 0C0.909352 0 0 0.941723 0 2.09927L0 17.1034C0 18.2609 0.909352 19.2027 2.02718 19.2027L3.59311 19.2027L3.59311 24.7884C3.59311 25.144 3.79997 25.4648 4.11736 25.6009C4.22241 25.6461 4.3328 25.6679 4.4422 25.6679C4.66327 25.6679 4.88039 25.5785 5.04288 25.4103L11.0371 19.2028L12.2397 19.2028C12.7088 19.2028 13.089 18.8091 13.089 18.3233C13.089 17.8375 12.7086 17.4438 12.2397 17.4438C12.2397 17.4438 10.6443 17.4449 10.6277 17.4467C10.4299 17.4606 10.2359 17.5449 10.0847 17.7014L5.29158 22.6651C5.29158 22.6651 5.2901 18.2677 5.28736 18.2449C5.24904 17.7959 4.88538 17.4438 4.44192 17.4438L2.02718 17.4438C1.84591 17.4438 1.69854 17.2911 1.69854 17.1034L1.69854 2.09927C1.69854 1.91155 1.84598 1.75893 2.02718 1.75893L26.1766 1.75893C26.3579 1.75893 26.5053 1.91163 26.5053 2.09927L26.5053 7.8557C26.5053 8.34146 26.8856 8.73517 27.3545 8.73517C27.8234 8.73517 28.2038 8.34146 28.2038 7.8557L28.2038 2.09927C28.2038 0.941723 27.2944 0 26.1766 0Z",
    transform: "translate(0 0.05519417)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02718 0L18.9314 0C20.0492 0 20.9585 0.941723 20.9585 2.09927L20.9585 12.335C20.9585 13.4926 20.049 14.4343 18.9313 14.4343L18.3476 14.4343L18.3476 18.2527C18.3476 18.6085 18.1406 18.9291 17.8234 19.0653C17.7183 19.1104 17.6079 19.1323 17.4985 19.1323C17.2775 19.1323 17.0603 19.0429 16.8979 18.8747L12.6102 14.4344L2.02718 14.4344C0.909352 14.4344 0 13.4926 0 12.335L0 2.09934C0 0.941723 0.909422 0 2.02718 0ZM18.9314 12.6754C19.1126 12.6754 19.2601 12.5227 19.2601 12.335L19.2601 2.09927C19.2601 1.91163 19.1126 1.75893 18.9314 1.75893L2.02718 1.75893C1.84598 1.75893 1.69854 1.91155 1.69854 2.09927L1.69854 12.335C1.69854 12.5226 1.84591 12.6753 2.02718 12.6753L12.9625 12.6753C13.1768 12.6753 13.372 12.7582 13.5215 12.894C13.5323 12.9035 13.5438 12.9141 13.5559 12.9264C13.5591 12.9297 13.5625 12.9328 13.5657 12.9362L16.6492 16.1295C16.6492 16.1295 16.6506 13.5063 16.6528 13.487C16.6864 13.033 17.0518 12.6754 17.4987 12.6754L18.9314 12.6754Z",
    transform: "translate(15.04146 10.81252)",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.849235 0C0.380461 0 0 0.394005 0 0.879466C0 1.36493 0.380461 1.75893 0.849235 1.75893C1.31808 1.75893 1.69847 1.36493 1.69847 0.879466C1.69847 0.394005 1.31801 0 0.849235 0Z",
    transform: "translate(24.67167 17.15024)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3055 0C16.3055 0 0.849234 0 0.849234 0C0.38025 0 0 0.393714 0 0.879466C0 1.36522 0.38032 1.75893 0.849234 1.75893L16.3055 1.75893C16.7745 1.75893 17.1547 1.36522 17.1547 0.879466C17.1547 0.393714 16.7745 0 16.3055 0Z",
    transform: "translate(5.524594 5.869733)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71505 0L0.849234 0C0.38025 0 0 0.393714 0 0.879466C0 1.36522 0.38032 1.75893 0.849234 1.75893L6.71505 1.75893C7.18411 1.75893 7.56429 1.36522 7.56429 0.879466C7.56429 0.393714 7.18404 0 6.71505 0Z",
    transform: "translate(5.524594 11.68434)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.849235 0C0.380531 0 0 0.394005 0 0.879466C0 1.36493 0.380531 1.75893 0.849235 1.75893C1.31808 1.75893 1.69847 1.36493 1.69847 0.879466C1.69847 0.394005 1.31808 0 0.849235 0Z",
    transform: "translate(20.72524 17.15024)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.849235 0C0.380461 0 0 0.394005 0 0.879466C0 1.36493 0.380461 1.75893 0.849235 1.75893C1.31808 1.75893 1.69847 1.36493 1.69847 0.879466C1.69847 0.394005 1.31801 0 0.849235 0Z",
    transform: "translate(28.61726 17.15024)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.480828bac5fe45a7bcadc91ec7f42c3f.svg";
export { ForwardRef as ReactComponent };